const GLOBAL = {
  LOADING: 'GLOBAL.LOADING',
  LOADED: 'GLOBAL.LOADED',
  LOAD_ERROR: 'GLOBAL.LOAD_ERROR',
  SERVER_ERROR: 'GLOBAL.SERVER_ERROR',
  NAVIGATE_FROM_EXT: 'GLOBAL.NAVIGATE_FROM_EXT',
  NAVIGATE_TO_EXT: 'GLOBAL.NAVIGATE_TO_EXT',
  CURRENT_SITE: 'GLOBAL.CURRENT_SITE',
}

export default GLOBAL
